// extracted by mini-css-extract-plugin
export default {"tableBodyInfo":"TableBody__tableBodyInfo--1Vw","tableBodyEmpty":"TableBody__tableBodyEmpty--2gm"};